import { Alert as MuiAlert, AlertProps as MuiAlertProps, styled } from "@mui/material";

const StyledAlert = styled(MuiAlert)(() => {
  return {};
});

interface AlertProps extends MuiAlertProps {
  children: React.ReactNode;
}

export const Alert: React.FC<AlertProps> = ({ children, ...props }) => {
  return <StyledAlert {...props}> {children}</StyledAlert>;
};

export default Alert;
